import React from 'react';
import {Container, Panel, Text} from '@wonderlandengine/react-ui/components';
import {colorSwatch} from '../utils/colorSwatch.js';
import {Align, FlexDirection, Justify} from '@wonderlandengine/react-ui';
import {setAlpha} from '../utils/utils.js';

export const Header = (props: {
    title: string;
    subtitle?: string;
    color?: string;
    center?: boolean;
    height?: number;
}) => {
    return (
        <Panel
            rounding={0}
            height={props.height ?? 40}
            backgroundColor={props.color ?? colorSwatch.SubTitleBackground}
            flexDirection={FlexDirection.Row}
            alignContent={Align.Center}
            padding={10}
            justifyContent={Justify.SpaceBetween}
        >
            <Container width={props.center === true ? '100%' : 'auto'}>
                <Text textAlign={props.center === true ? 'center' : 'left'} fontSize={26}>
                    {props.title}
                </Text>
            </Container>
            {props.subtitle && (
                <Text
                    color={setAlpha(colorSwatch.DescriptionText, '75%')}
                    fontSize={22}
                    textAlign="right"
                >
                    {props.subtitle}
                </Text>
            )}
        </Panel>
    );
};
